import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Layout from './components/Layout'
import LoginMinimal from './pages/Login-minimal'
import Dashboard from './pages/Dashboard'
import Zones from './pages/Zones'
import ZoneEditor from './pages/ZoneEditor'
import ZoneFileEditor from './pages/ZoneFileEditor'
import ZoneEditorLive from './pages/ZoneEditorLive'
import Monitoring from './pages/Monitoring'
import BindManager from './pages/BindManager'
import ConfigBuilderEnhanced from './pages/ConfigBuilderEnhanced'
import Users from './pages/Users'
import Settings from './pages/Settings'
import NotFound from './pages/NotFound'
import PtrRecords from './pages/PtrRecords'

// Simple auth - just check if token exists in localStorage
const getToken = () => localStorage.getItem('token')

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Delay auth check to ensure localStorage is ready after page reload
    const timer = setTimeout(() => {
      const token = getToken()
      console.log('App auth check - token:', token?.substring(0, 20))
      setIsAuthenticated(!!token)
      setIsLoading(false)
    }, 500)
    
    return () => clearTimeout(timer)
  }, [])

  const handleLogin = () => {
    setIsAuthenticated(true)
  }

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    setIsAuthenticated(false)
  }

  if (isLoading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <div>Loading...</div>
      </div>
    )
  }

  return (
    <Routes>
      <Route 
        path="/login" 
        element={
          isAuthenticated ? (
            <Navigate to="/" replace />
          ) : (
            <LoginMinimal onLogin={handleLogin} />
          )
        } 
      />
      <Route 
        path="/" 
        element={
          isAuthenticated ? (
            <Layout />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="zones" element={<Zones />} />
        <Route path="zones/:id" element={<ZoneEditor />} />
        <Route path="zones/new" element={<ZoneEditor />} />
        <Route path="zone-editor" element={<ZoneFileEditor />} />
        <Route path="zone-editor-live" element={<ZoneEditorLive />} />
        <Route path="monitoring" element={<Monitoring />} />
        <Route path="ptr" element={<PtrRecords />} />
        <Route path="/dns" element={<BindManager />} />
        <Route path="/config-builder" element={<ConfigBuilderEnhanced />} />
        <Route path="/users" element={<Users />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default App
